import { cubic } from "../cubic";

var cubicu = function(i) {
  var t = 0.25;
  var e = 0.46;
  var n = 0.45;
  var r = 0.94;
  for (var s = 0, o = 1; ; ) {
    var a = function(t, e, n) {
        return (
          3 * t * (1 - n) * (1 - n) * n + 3 * e * (1 - n) * n * n + n * n * n
        );
      },
      u = (s + o) / 2,
      l = a(t, n, u);
    if (Math.abs(i - l) < 0.001) return a(e, r, u);
    l < i ? (s = u) : (o = u);
  }
};

export { cubicu };
